import { calcExtra } from "@/components/OrderItemsEditor";

const GST_OPTIONS = [0, 5, 12, 18, 28];

function Row({ label, testId, charge, rate, mode, onChange }) {
  const t = calcExtra(charge, rate, mode);
  return (
    <div className="grid grid-cols-1 md:grid-cols-6 gap-2 items-end" data-testid={`extra-${testId}`}>
      <div>
        <div className="overline mb-1">{label} (₹)</div>
        <input type="number" step="0.01" value={charge}
          onChange={(e) => onChange({ charge: e.target.value })}
          className="w-full border border-[hsl(var(--border))] bg-transparent px-2 py-1.5 text-sm outline-none" data-testid={`extra-${testId}-charge`} />
      </div>
      <div className="md:col-span-2">
        <div className="overline mb-1">GST</div>
        <select value={mode} onChange={(e) => onChange({ mode: e.target.value })}
          className="w-full border border-[hsl(var(--border))] bg-transparent px-2 py-1.5 text-sm outline-none" data-testid={`extra-${testId}-mode`}>
          <option value="none">No GST</option>
          <option value="excluded">Add GST on top</option>
          <option value="included">GST already included</option>
        </select>
      </div>
      <div>
        <div className="overline mb-1">Rate</div>
        <select value={rate} onChange={(e) => onChange({ rate: Number(e.target.value) })}
          disabled={mode === "none"}
          className="w-full border border-[hsl(var(--border))] bg-transparent px-2 py-1.5 text-sm outline-none disabled:opacity-40" data-testid={`extra-${testId}-rate`}>
          {GST_OPTIONS.map((g) => <option key={g} value={g}>{g}%</option>)}
        </select>
      </div>
      <div className="md:col-span-2 grid grid-cols-3 gap-2 text-xs">
        <div><div className="overline">Base</div><div className="font-mono">₹{Math.round(t.base).toLocaleString("en-IN")}</div></div>
        <div><div className="overline">GST</div><div className="font-mono">₹{Math.round(t.tax).toLocaleString("en-IN")}</div></div>
        <div><div className="overline">Total</div><div className="font-mono font-semibold">₹{Math.round(t.total).toLocaleString("en-IN")}</div></div>
      </div>
    </div>
  );
}

export default function ExtrasEditor({ form, set }) {
  return (
    <div className="space-y-4">
      <Row label="Transport Charge" testId="transport"
        charge={form.transport_charge} rate={form.transport_gst_rate} mode={form.transport_gst_mode}
        onChange={(p) => set({
          transport_charge: p.charge ?? form.transport_charge,
          transport_gst_rate: p.rate ?? form.transport_gst_rate,
          transport_gst_mode: p.mode ?? form.transport_gst_mode,
        })} />
      <Row label="Installation Charge" testId="install"
        charge={form.installation_charge} rate={form.installation_gst_rate} mode={form.installation_gst_mode}
        onChange={(p) => set({
          installation_charge: p.charge ?? form.installation_charge,
          installation_gst_rate: p.rate ?? form.installation_gst_rate,
          installation_gst_mode: p.mode ?? form.installation_gst_mode,
        })} />
    </div>
  );
}
